/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from "react";
import WalletLottie from "../Lottie/wallet.json";
import Lottie from "lottie-react";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { FaWallet } from "react-icons/fa";
import { showToast } from "../../showTost";
import {
  LuWallet,
  LuChevronRight,
  LuArrowDownLeft,
  LuArrowUpRight,
  LuPlus,
} from "react-icons/lu";
import { IoChevronBackOutline, IoCloseSharp } from "react-icons/io5";
import Razorpay from "../../Payment/RazorPay";
import PayPal from "../../Payment/PayPal";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import Stripe from "../../Payment/Stripe";
import Paystack from "../../Payment/Paystack";
import Flutterwave from "../../Payment/Flutterwave";
import SenangPay from "../../Payment/SenangPay";
import PayFast from "../../Payment/PayFast";
import Midtrans from "../../Payment/Midtrans";
import ImageLoad from "../ImageLoad";
import { useNavigate } from "react-router-dom";

const Wallet = () => {
  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl, paymentStatus, setPaymentStatus } =
    useContext(MyContext);
  const navigate = useNavigate();

  const [mywallet, setMyWallet] = useState();
  const [history, setHistory] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [isPaymentShow, setIsPaymentShow] = useState(false);
  const [paymentList, setPaymentList] = useState([]);
  const [selectPaymentId, setSelectPaymentId] = useState();
  const [attribute, setAttribute] = useState("");
  const [input, setInput] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totallength, setTotalLength] = useState(0);

  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);

  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";
  const Userid = secureLocalStorage.getItem("Userid");

  useEffect(() => {
    HandlefetchData(1);
    HandleGetPaymentList();
  }, []);

  const HandlefetchData = (page) => {
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/wallet_transaction_list`, {
          id: Userid,
          page,
        })
        .then((res) => {
          // console.log("wallet_transaction_list", res);
          if (res.data.ResponseCode === 200) {
            const { tot_balance, wallet_list } = res.data;
            if (wallet_list.length === 0 || totallength > wallet_list.length) {
              NoMoreDataRef.current = false;
            }
            if (page === 1) {
              setHistory(wallet_list);
              setTotalLength(tot_balance.length);
            } else {
              setHistory((prev) => [...prev, ...wallet_list]);
            }
            setLoading(false);
            setMyWallet(tot_balance);
            secureLocalStorage.setItem("wallet", tot_balance);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;
      if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
        hasReachedBottom.current = true;
        setPage((prevPage) => prevPage + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (page === 1 || !NoMoreDataRef.current) return;
    HandlefetchData(page);
  }, [page]);

  const HandleGetPaymentList = () => {
    if (Userid) {
      axios
        .get(`${ApiBaseUrl}/customer/wallet_payment_list`)
        .then((res) => {
          // console.log("wallet_payment_list", res);
          setPaymentList(res.data.payment_list);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const SelectPayment = (item) => {
    setSelectPaymentId(item.id);
    setAttribute(item.attribute);
  };

  const HandleContinue = () => {
    if (!input) {
      showToast({ title: t("Please Enter Amount"), id: "error" });
      return;
    }
    if (!selectPaymentId) {
      showToast({ title: t("Select Payment Method"), id: "error" });
      return;
    }
    sessionStorage.setItem("Paymentid", selectPaymentId);
    setIsPaymentShow(true);
  };

  useEffect(() => {
    if (!paymentStatus) return;
    if (paymentStatus === "PaymentDone") {
      HandlePaymeDone();
      setPaymentStatus("");
      setIsPaymentShow(false);
    } else {
      setPaymentStatus("");
      setIsPaymentShow(false);
      setIsShow(false);
      setSelectPaymentId("");
    }
  }, [paymentStatus]);

  const HandlePaymeDone = () => {
    const PaymentId = sessionStorage.getItem("Paymentid");
    axios
      .post(`${ApiBaseUrl}/customer/add_wallet`, {
        id: Userid,
        amount: input,
        payment_type: PaymentId || selectPaymentId,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.ResponseCode == 200) {
          HandlefetchData(1);
          setIsShow(false);
          showToast({ title: res.data.message, id: "success" });
          sessionStorage.removeItem("Paymentid");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div className="wallet-container w-full min-h-screen pb-[100px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading
          CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]"
          index={0}
        />
      ) : (
        <div className="flex flex-col">
          {/* Header Navigation */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
            >
              <IoChevronBackOutline className="w-4 h-4" />
              <span className="font-medium text-sm">{t("Go Back")}</span>
            </button>
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <span
                className="hover:text-indigo-600 font-medium transition-colors cursor-pointer"
                onClick={() => navigate("/dashbord")}
              >
                {t("Dashboard")}
              </span>
              <LuChevronRight className="w-3.5 h-3.5" />
              <span className="font-semibold text-slate-800">
                {t("My Wallet")}
              </span>
            </div>
          </div>

          {/* Wallet Balance Banner */}
          <div className="bg-gradient-to-br from-indigo-600 via-indigo-500 to-violet-600 rounded-3xl p-6 sm:p-8 mb-6 flex flex-col sm:flex-row items-center sm:items-start justify-between gap-6 shadow-lg shadow-indigo-200 relative overflow-hidden">
            {/* Decorative blobs */}
            <div className="absolute -top-10 -right-10 w-48 h-48 bg-white/10 rounded-full blur-2xl pointer-events-none" />
            <div className="absolute -bottom-8 -left-8 w-36 h-36 bg-white/10 rounded-full blur-2xl pointer-events-none" />

            <div className="flex items-center gap-5 z-10">
              <div className="w-16 h-16 bg-white/20 border border-white/30 rounded-2xl flex items-center justify-center shrink-0 shadow-inner">
                <Lottie
                  animationData={WalletLottie}
                  loop={true}
                  className="w-10 h-10"
                />
              </div>
              <div>
                <span className="text-white/70 text-xs font-bold uppercase tracking-widest block">
                  {t("TOTAL WALLET BALANCE")}
                </span>
                <h2 className="text-white font-black text-3xl sm:text-4xl mt-1">
                  {currency} {mywallet}
                </h2>
              </div>
            </div>

            <button
              onClick={() => setIsShow(true)}
              className="z-10 inline-flex items-center gap-2 bg-white text-indigo-600 font-bold text-sm px-6 py-3 rounded-2xl shadow-md hover:bg-indigo-50 active:scale-95 transition-all duration-150 shrink-0"
            >
              <LuPlus className="w-4 h-4" />
              {t("Top Up")}
            </button>
          </div>

          {/* Transaction History */}
          <div className="bg-white rounded-3xl border border-slate-150 shadow-sm p-6">
            <h3 className="font-bold text-slate-800 text-lg mb-5">
              {t("Transaction History")}
            </h3>

            {history.length >= 1 ? (
              <div className="flex flex-col divide-y divide-slate-100">
                {history.map((item, index) => {
                  const isCredit =
                    item.status === "1" ||
                    item.status === "3" ||
                    item.status === "5" ||
                    item.status === "7";
                  return (
                    <div
                      key={index}
                      className="flex items-center justify-between py-4 first:pt-0 last:pb-0"
                    >
                      <div className="flex items-center gap-4">
                        <div
                          className={`w-11 h-11 rounded-2xl flex items-center justify-center shrink-0 ${isCredit ? "bg-emerald-50 border border-emerald-100" : "bg-rose-50 border border-rose-100"}`}
                        >
                          {isCredit ? (
                            <LuArrowDownLeft className="w-5 h-5 text-emerald-600" />
                          ) : (
                            <LuArrowUpRight className="w-5 h-5 text-rose-500" />
                          )}
                        </div>
                        <div>
                          <h4 className="font-bold text-slate-800 text-sm">
                            {item.date}
                          </h4>
                          <span
                            className={`text-xs font-bold ${isCredit ? "text-emerald-600" : "text-rose-500"}`}
                          >
                            {isCredit ? t("Credit") : t("Debit")}
                          </span>
                        </div>
                      </div>
                      <span
                        className={`font-black text-base ${isCredit ? "text-emerald-600" : "text-rose-500"}`}
                      >
                        {isCredit ? "+" : "-"}
                        {currency}
                        {item.amount}.0
                      </span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="py-16 flex flex-col items-center justify-center text-center">
                <div className="w-16 h-16 bg-slate-50 border border-slate-100 rounded-full flex items-center justify-center mb-4 shadow-inner">
                  <FaWallet className="text-slate-300 text-2xl" />
                </div>
                <h4 className="font-bold text-slate-800 text-base mb-1">
                  {t("No Transactions Yet")}
                </h4>
                <p className="text-slate-400 text-sm">
                  {t("Go & Add your Amount")}
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ─── Top Up Modal ──────────────────────────────────── */}
      {isShow && (
        <div
          onClick={() => setIsShow(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[85vh] flex flex-col gap-5 relative overflow-hidden"
          >
            <button
              onClick={() => setIsShow(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>

            <div>
              <h2 className="font-bold text-slate-800 text-lg">
                {t("Add Wallet Amount")}
              </h2>
              <p className="text-slate-400 text-xs font-semibold uppercase tracking-wider mt-0.5">
                {t("Top up your wallet balance")}
              </p>
            </div>

            {/* Amount Input */}
            <div className="flex items-center gap-3 border-2 border-slate-200 focus-within:border-indigo-600 rounded-2xl py-3 px-4 transition-colors duration-150 bg-slate-50">
              <LuWallet className="text-slate-400 w-5 h-5 shrink-0" />
              <input
                onChange={(e) => setInput(e.target.value)}
                type="number"
                placeholder={t("Enter Amount")}
                className="w-full bg-transparent outline-none text-slate-800 font-bold text-base placeholder:text-slate-400 placeholder:font-medium"
              />
              <span className="text-slate-400 font-bold text-sm shrink-0">
                {currency}
              </span>
            </div>

            {/* Payment Methods */}
            <div className="flex flex-col gap-2">
              <span className="text-slate-500 text-xs font-bold uppercase tracking-wider">
                {t("Select Payment Method")}
              </span>
              <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto pr-1 scroll-container">
                {paymentList.length >= 1 ? (
                  paymentList.map((item, index) => (
                    <label
                      key={index}
                      onClick={() => SelectPayment(item)}
                      className={`flex items-center gap-3 p-3.5 border rounded-2xl cursor-pointer transition-all duration-150 ${
                        selectPaymentId === item.id
                          ? "border-indigo-600 bg-indigo-50/30"
                          : "border-slate-200 hover:border-slate-300"
                      }`}
                    >
                      <div className="w-12 h-12 rounded-xl overflow-hidden border border-slate-150 shrink-0 bg-slate-50">
                        <ImageLoad
                          src={ImgBaseUrl + item.image}
                          CustomeStyle="w-full h-full object-cover"
                          alt="Payment Img"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="font-bold text-slate-800 text-sm">
                          {item.name}
                        </h4>
                        <p className="text-slate-400 text-xs font-medium">
                          {item.sub_title}
                        </p>
                      </div>
                      <div
                        className="w-5 h-5 rounded-full flex items-center justify-center border-2 shrink-0 transition-colors duration-150 border-slate-300 border-solid"
                        style={{
                          borderColor:
                            selectPaymentId === item.id ? "#4f46e5" : undefined,
                        }}
                      >
                        <span
                          className={`w-2.5 h-2.5 rounded-full transition-all duration-150 ${selectPaymentId === item.id ? "bg-indigo-600 scale-100" : "scale-0"}`}
                        ></span>
                      </div>
                    </label>
                  ))
                ) : (
                  <div className="h-24 flex items-center justify-center">
                    <span className="text-slate-400 text-sm font-medium animate-pulse">
                      Loading...
                    </span>
                  </div>
                )}
              </div>
            </div>

            <button
              onClick={HandleContinue}
              className="w-full h-12 bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-sm rounded-2xl flex items-center justify-center gap-2 shadow-md shadow-indigo-600/20 transition-all duration-150 active:scale-95"
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}

      {selectPaymentId === 1 && isPaymentShow && (
        <Razorpay Amount={input} Attribute={attribute} />
      )}
      {selectPaymentId === 2 && isPaymentShow && (
        <PayPal Amount={input} Attribute={attribute} />
      )}
      {selectPaymentId === 3 && isPaymentShow && <Stripe Amount={input} />}
      {selectPaymentId === 4 && isPaymentShow && <Paystack Amount={input} />}
      {selectPaymentId === 5 && isPaymentShow && <Flutterwave Amount={input} />}
      {selectPaymentId === 7 && isPaymentShow && <SenangPay Amount={input} />}
      {selectPaymentId === 9 && isPaymentShow && <PayFast Amount={input} />}
      {selectPaymentId === 10 && isPaymentShow && <Midtrans Amount={input} />}
    </div>
  );
};

export default Wallet;
/* jshint ignore:end */
